<template>
  <div class="lt-sm">
    {{ term > 1 ? `${term} Mo` : 'Month to Month' }}
  </div>
  <div class="gt-xs">
    {{ term > 1 ? `${term} Months` : 'Month to Month' }}
  </div>
</template>

<script>
export default {
  name: "PlanTerm",
  props: {
    term: {
      type: Number
    }
  }
}
</script>

<style scoped>

</style>